import React from 'react';

import { HorizontalProductCard } from '@hero/molecules';

import * as S from './style';

function ProductList({ productContainerStyle, products, openModal, onRemoveProduct }) {
  return (
    <S.ProductList style={productContainerStyle}>
      {products.map(product => {
        return (
          <HorizontalProductCard
            key={product.merchantProductId}
            product={product}
            isSelected
            openModal={() => openModal({ product, isSelected: true })}
            removeProduct={() => onRemoveProduct(product)}
            editProduct={() => openModal({ product, isSelected: true })}
          />
        );
      })}
    </S.ProductList>
  );
}

export { ProductList };
